<div class="content">


    <!-- <mat-icon class="text-sucess">check_circle</mat-icon> -->
    <fa-icon class="text-sucess" size="5x" [icon]="['fas', 'check-circle']" >  </fa-icon>
    <h1 class="text-sucess">La actualización  fue realizada</h1>
  
  
  <button class="text-sucess" mat-stroked-button [routerLink]="['/home']">Aceptar</button>
</div>
  